import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

import Loader from '../../utils/Loader'
import OrderLayout from '../../Order'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

class Order extends Component {
    constructor(props){
        super(props)

        this.state = {
            id: this.props.match.params.id,
            isLoading: true,
            data: null,
            error: ''
        }
    }

    componentDidMount() {
        this.loadOrder()
    }

    loadOrder(){
        const { id } = this.state

        const apiEndpoint = 'order/' + id
    
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({ isLoading: false, error: response.data.message })
            }else{
                this.setState({ isLoading: false, data: { ...response.data } })
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            }else{
                this.setState({ isLoading: false, error: err.message })
            }
		})
    }

    render() {
        return (
            <div>
                {/* Has error */}
                {this.state.error ? (
                    <div className="error">
                        {Object.keys(this.state.error).map(key => 
                            <span key={key}>{this.state.error[key]}</span>
                        )}
                    </div>
            
                // No error
                ) : (
                    
                    // Loading
                    this.state.isLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    
                    // Show order data
                    ) : (
                        <div>
                            {!isEmpty(this.state.data.order) ? (
                                <div>
                                    <OrderLayout order={this.state.data.order} />

                                    {/* <div className="btn_container right-aligned">
                                        <a className="btn" target="_blank" href="view-order?order={{order.id}}">Print</a>
                                    </div> */}
                                </div>
                            ) : (
                                <div>Unable to find the order</div>
                            )}
                        </div>
                    )
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		user: state.user.admin
	}
}

export default connect(mapStateToProps)(Order)



// WEBPACK FOOTER //
// ./src/components/admin/orders/Order.js